<template>
  <form @submit.prevent="submitOrUpdateShortlist">

    <div class="form-group double vanilla" :class="{'has-input-error': errors.label}">
      <label for="shortlist-label">* Project name</label>
      <input id="shortlist-label" type="text" name="label" v-model="shortlist.label" required/>
      <input-error v-if="errors.label">
        {{ errors.label[0] }}
      </input-error>
    </div>

    <div class="form-group double vanilla" :class="{'has-input-error': errors.brand_name}">
      <label for="shortlist-brand_name">Brand name</label>
      <input id="shortlist-brand_name" type="text" name="brand_name" v-model="shortlist.brand_name"/>
      <input-error v-if="errors.brand_name">
        {{ errors.brand_name[0] }}
      </input-error>
    </div>

    <div class="form-group double vanilla" :class="{'has-input-error': errors.agency_name}">
      <label for="shortlist-agency_name">Agency name</label>
      <input id="shortlist-agency_name" type="text" name="agency_name" v-model="shortlist.agency_name"/>
      <input-error v-if="errors.agency_name">
        {{ errors.agency_name[0] }}
      </input-error>
    </div>

    <div class="form-group vanilla submit">
      <loader-button
          type="submit"
          :loading="loading"
          label="Submit"
          class="button primary green block new-shortlist-submit-btn-gtm"
      ></loader-button>
    </div>

  </form>
</template>

<script>
import BaseModal from '../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      shortlist: {
        label: '',
        brand_name: '',
        agency_name: ''
      },
      isEditing: false,
      loading: false,
      errors: {}
    }
  },
  methods: {
    submitOrUpdateShortlist () {
      if (this.isEditing) {
        return this.updateShortlist();
      }

      this.submitShortlist();
    },

    submitShortlist() {
      this.loading = true
      axios.post('/api/account/shortlists/create', {
        label: this.shortlist.label,
        agency_name: this.shortlist.agency_name,
        brand_name: this.shortlist.brand_name
      })
          .then(response => {
            window.dataLayer.push({event: 'shortlist-submit'});

            this.$store.dispatch("intercom/track", {
              type: "User created a shortlist",
              meta: {
                  label: this.shortlist.label,
                  agency_name: this.shortlist.agency_name,
                  brand_name: this.shortlist.brand_name
              },
            });
            console.log('Intercom New: User created a shortlist', {label: this.shortlist.label, agency_name: this.shortlist.agency_name, brand_name: this.shortlist.brand_name});

            this.$store.commit('user/updateShortlists', response.data.all)
            this.shortlist.label = null
            this.shortlist.agency_name = null
            this.shortlist.brand_name = null

            this.$emit('confirm', {shortlist: response.data.created})
          })
          .catch(error => {
            this.$toasted.show('Your shortlist could not be created, please review errors and try again.', {
              type: 'error'
            })
            this.errors = error.response.data.errors || {}
          })
          .then(() => {
            this.loading = false
          })
    },
    updateShortlist() {
      this.loading = true
      axios.put('/api/account/shortlists/' + this.data.id, {
        label: this.shortlist.label,
        agency_name: this.shortlist.agency_name,
        brand_name: this.shortlist.brand_name
      })
          .then(response => {
            this.$store.commit('user/updateShortlists', response.data.all)
            this.shortlist.label = null
            this.shortlist.agency_name = null
            this.shortlist.brand_name = null

            this.$emit('confirm', {shortlist: response.data.created})
          })
          .catch(error => {
            this.$toasted.show('Your shortlist could not be updated, please review errors and try again.', {
              type: 'error'
            })
            this.errors = error.response.data.errors || {}
          })
          .then(() => {
            this.loading = false
          })
    }
  },
  mounted() {
    if (this.data?.id) {
      this.isEditing = true
      this.shortlist.label = this.data.label
      this.shortlist.agency_name = this.data.agency_name
      this.shortlist.brand_name = this.data.brand_name
    }
  }
}
</script>
